import {
    Box,
    Flex,
    Spinner, 
    useToast,
  
  } from '@chakra-ui/react'
  import React, { Fragment, useState, useEffect, useContext } from 'react'
  import { useParams } from 'react-router-dom'
  import Details from '../../../component/Details'
  import DetailsHeader from '../../../component/DetailsHeader'
  import RightSidebar from '../../../component/RightSidebar'
  import axios from 'axios'
  import { Auth } from '../../../component/Auth'
  import { Context } from '../../../component/store'
  
  
  const DeliveryOrderDetails = () => {

    const [orderData, setOrderData] = useState({})
    const [tenureData, setTenureData] = useState(null)
    const [renderOnStatusChange, setRenderOnStatusChange] = useState("")
    const [renderOnDeliveredChange, setRenderOnDeliveredChange] = useState(0)
    // const [savePartyDetails, setSavePartyDetails] = useState("")
    const { id } = useParams()
    const toast = useToast()
    const { userData } = useContext(Context)
    const user = userData
  
   
    // let statusItems = [{ status: "ORDER_DELIVERED", title: "Delivered" },{ status: "ORDER_CANCELED", title: "Canceled" }]
    let statusItems = (user.UserGroupPermission.includes('ORDER_MANAGEMENT') || user.userGroupMember.includes("ADMIN")) ? [{status: "ORDER_DELIVERED", title: "Delivered" },{ status: "ORDER_CANCELED", title: "Canceled" }] : [{ status: "ORDER_DELIVERED", title: "Delivered" }]

  
 
  
    
  
    // status change function render
    const handleChildStateChange = (newState) => {
      setRenderOnStatusChange(newState);
    };
    // on delevered status success
    const deliveredRender = () => {
      setRenderOnDeliveredChange((prev) => renderOnDeliveredChange + 1)
    }
    
  
    // get order by id
    useEffect(() => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': Auth()
        },
      };
      axios.request(config)
        .then((response) => {
          setOrderData(response.data)
          // fetching all tenure details ------------
          let data = JSON.stringify({
            "orderId": response.data?.OrderItem[0].orderId,
          });
  
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': Auth()
            },
            data: data
          };
  
          axios.request(config)
            .then((response) => {
              setTenureData(response.data)
              if (response.data.length === 0) {
                toast({
                  title: `Tenure data not found`,
                  position: 'top',
                  status: 'warning',
                  duration: 5000,
                  isClosable: true,
                })
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
  
    }, [id, toast, renderOnStatusChange, renderOnDeliveredChange])
  
  
    // Format Date ----
    const formatDate = (date) => {
      const options = {
        year: "2-digit",
        month: "short",
        day: "numeric",
      };
      const dateString = date.toLocaleDateString("en-US", options);
      const timeString = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
      return `${dateString}, ${timeString}`
    }
  
  
  
  
    switch (orderData?.orderStatusId) {
      case 'ORDER_OUT_FOR_DELIVERY':
        statusItems = statusItems.filter((d) => (d.status === "ORDER_DELIVERED") || (d.status === "ORDER_CANCELED"));
        break;
      case 'ORDER_DELIVERED':
        statusItems = [];
        break;
      case 'ORDER_CANCELED':
        statusItems = [];
        break;
      default:
        statusItems = []
    }
  
 
  
  
    return (
      <Fragment>
  
        {(Object.keys(orderData).length > 0) && (tenureData !== null) ?
          <Box width={{base: '100%', md: '100%', lg: '80%', xl: '80%', '2xl': '80%'}}>
            <Flex p={5} pb={0}>
              <Box flexBasis={'100%'}>
                <DetailsHeader
                  title={"Order ID"}
                  colorScheme={'blackAlpha'}
                  variant={'solid'}
                  menuItems={statusItems}
                  changeStatusId={null}
                  orderName={orderData?.OrderName.includes('#') ? orderData?.OrderName : 'Draft'}
                  handleChildStateChange={handleChildStateChange}
                  deliveredRender={deliveredRender}
                  orderData={orderData}
                  tenureData={tenureData}
                  mobile={orderData.customerParty?.phone}
                  
                  />
              </Box>
            
            </Flex> 
            <Flex justifyContent={{base: 'center', md: 'center', lg: 'space-evenly', xl: 'space-evenly', '2xl': 'space-evenly'}} flexDirection={{base: 'column', md: 'column', lg: 'row', xl: 'row', '2xl': 'row'}}>
              <Box  p={5} py={{base: 3, md: 3, lg: 5, xl: 5, '2xl': 5}} w={{base: '100%', md: '100%', lg: '70%', xl: '70%', '2xl': '70%'}} pb={{base: 0, md: 0, lg: 5, xl: 5, '2xl': 5}} bgColor='#F5F5F5'>
  
  
                {orderData?.OrderItem?.map((d, i) => {
       
  
             
                  return (
                    <Details
                      key={i}
                      orderDetails={{title: d.title, variant: d.variant, img: d.productImg, quantity: d.quantity, orderItemSeqId: d.orderItemSeqId, selectedGamesType: d?.selectedGamesType || 'n/a', productGeneration: d?.productGeneration || 'n/a' , productProcessor: d?.productProcessor || 'n/a' , productOperatingSystem: d?.productOperatingSystem || 'n/a' }}
                      title={"Order"}
                      order={"Order Placed"}
                      title2={"Order Delivery"}
                      orderId={id}
                      btnColorScheme={(orderData?.orderStatusId === 'ORDER_CREATED' && 'green') ||
                        (orderData?.orderStatusId === 'ORDER_PUBLISHED' && 'facebook') ||
                        (orderData?.orderStatusId === 'ORDER_DRAFT' && 'purple') ||
                        (orderData?.orderStatusId === 'ORDER_VERIFIED' && 'whatsapp') ||
                        (orderData?.orderStatusId === 'ORDER_DELIVERED' && 'yellow') ||
                        (orderData?.orderStatusId === 'ORDER_CANCELED' && 'red') ||
                        (orderData?.orderStatusId === 'ORDER_OUT_FOR_DELIVERY' && 'orange') ||
                        (orderData?.orderStatusId === 'ORDER_TRANSIT' && 'messenger') ||
                        (orderData?.orderStatusId === 'ORDER_RETURNED' && 'telegram') ||
                        (orderData?.orderStatusId === 'ORDER_PENDING_FOR_FULFILLMENT' && 'teal') ||
                        (orderData?.orderStatusId === 'ORDER_READY_FOR_FULFILLMENT' && 'linkedin') ||
                        (orderData?.orderStatusId === 'ORDER_PICKED' && 'pink') ||
                        (orderData?.orderStatusId === 'AWAITING_VERIFICATION' && 'cyan')}
                      btnText={orderData?.orderStatusId}
                      orderDate={formatDate(new Date(orderData?.placedDate))}
                      productName={'Product Name'}
                      // productBtnText={"Assign for Delivery"} 
                      // productBtnItems={["Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Deepak Sharma","Gagan Verma"]}
                      row1={[{ "Order Date": formatDate(new Date(orderData.placedDate)) }, { "Delivery Date": new Date((tenureData[0]?.tenure?.startDate)).toLocaleDateString('en-IN') }, { "Delivery Location": orderData?.shippingAddress?.city || '----' }, { "Delivery Time": `----` }]}
                      row2={[]}
                      status={'Order Draft'}
                    //   tenureLength={tenureData.length}
                    />)
                })}

              </Box>
              <Box pr={{base: 5, md: 5, lg: 3, xl: 3, '2xl': 3}} pl={{base: 5, md: 5, lg: 0, xl: 0, '2xl': 0}} mt={{base: 0, md: 0, lg: 5, xl: 5, '2xl': 5}}  w={{base: '100%', md: '100%', lg: '30%', xl: '30%', '2xl': '30%'}} bgColor='#F5F5F5'>
                <RightSidebar
                  customerName={orderData.customerParty?.firstName + ' ' + orderData.customerParty?.lastName}
                  customerGmail={orderData.customerParty?.email}
                  customerPhone={orderData.customerParty?.phone}
                  shippingArea={orderData.shippingAddress}
                  shippingCity={orderData.shippingAddress?.city}
                  billingAddress={orderData.billingAddress}
                  title={'Order'} />
              </Box>
            </Flex>
          </Box>
          :
          <Flex w={{base: '100%', md: '100%', lg: '80%', xl: '80%', '2xl': '80%'}} justifyContent={'center'} mt={8}>
            <Spinner
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              color='blue.500'
              size='xl'
            />
          </Flex>
  
        }
      </Fragment>
    )
  }
  
  export default DeliveryOrderDetails
  